<template>
	<section
		class="px-content py-20 will-change relative z-[1]"
		:data-scroll-section="inner == 'false'"
	>
		<ul class="tabs__nav mb-12">
			<li
				class="px-5 xl:px-16 text-lg xl:text-xl leading-snug flex flex-col transition-all"
				:class="{
					'active text-navy-blue-01': activeNeigbourhood === n,
					'text-navy-blue-03': activeNeigbourhood !== n,
				}"
				v-for="(n, index) in availableNeigbourhoods"
				:key="index"
				@click="
					activeNeigbourhood = n;
					updateScroll();
				"
			>
				<div class="font-canela font-light cursor-pointer whitespace-nowrap">
					{{ n.name }}
				</div>
			</li>
		</ul>

		<!-- filter -->
		<div
			class="filter-wrap mb-10 grid md:grid-cols-2 xl:grid-cols-4 gap-3 xl:gap-6 relative z-20"
		>
			<div
				class="flex items-center bg-white border border-light-grey rounded-sm relative"
			>
				<svg
					class="ml-4 flex-shrink-0"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M20.25 20.2528V10.8345C20.25 10.73 20.2282 10.6267 20.1859 10.5311C20.1436 10.4356 20.0818 10.3499 20.0045 10.2796L12.504 3.46068C12.3659 3.33516 12.186 3.26562 11.9995 3.26563C11.8129 3.26563 11.633 3.33519 11.4949 3.46071L3.99545 10.2796C3.91814 10.3499 3.85637 10.4356 3.8141 10.5311C3.77183 10.6267 3.75 10.73 3.75 10.8345V20.2528"
						stroke="#405664"
						stroke-width="1.2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M1.5 20.25H22.5"
						stroke="#405664"
						stroke-width="1.2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M14.2495 20.25V15C14.2495 14.8011 14.1704 14.6103 14.0298 14.4697C13.8891 14.329 13.6984 14.25 13.4995 14.25H10.4995C10.3005 14.25 10.1098 14.329 9.96912 14.4697C9.82847 14.6103 9.74945 14.8011 9.74945 15V20.25"
						stroke="#405664"
						stroke-width="1.2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
				<button
					class="flex flex-col flex-grow bg-gray-300 text-gray-700 font-semibold py-2 px-4"
					type="button"
					@click="toggle('filter-prop-type')"
				>
					<span class="text-[10px] text-mid-grey mb-1">{{
						__("Property Type", "ccave")
					}}</span>
					<div class="flex items-center w-full">
						<span id="property-type-title" class="mr-1 text-sm py-[5px]">{{
							__("All Property Types", "ccave")
						}}</span>
						<svg
							class="fill-current ml-auto -mt-3 h-4 w-4"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20"
						>
							<path
								d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
							/>
						</svg>
					</div>
				</button>
				<ul
					id="filter-prop-type"
					class="bg-white absolute hidden activity-select"
				>
					<li
						class=""
						v-for="(type, index) in propertyTypes"
						:key="index"
						@click="
							setFilter('type', type);
							toggle('filter-prop-type');
						"
					>
						<span class="block cursor-pointer px-6 py-4">{{ type.name }}</span>
					</li>
					<button
						type="button"
						class="block px-6 py-4"
						href="javascript:void(0);"
						@click="
							clearFilter('type');
							toggle('filter-prop-type');
						"
					>
						Clear
					</button>
				</ul>
			</div>
			<div
				class="flex items-center bg-white border border-light-grey rounded-sm relative"
			>
				<svg
					class="ml-4 flex-shrink-0"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M17.523 18.273C16.579 19.217 15.3762 19.8599 14.0669 20.1203C12.7575 20.3808 11.4003 20.2471 10.1669 19.7362C8.93348 19.2253 7.87928 18.3601 7.13758 17.2501C6.39588 16.1401 6 14.835 6 13.5V10.5C6 9.16498 6.39588 7.85994 7.13758 6.7499C7.87928 5.63987 8.93348 4.77471 10.1669 4.26382C11.4003 3.75292 12.7575 3.61925 14.0669 3.8797C15.3762 4.14015 16.579 4.78303 17.523 5.72703"
						stroke="#405664"
						stroke-width="1.2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M3.75 10.5H12.75"
						stroke="#405664"
						stroke-width="1.2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
					<path
						d="M3.75 13.5H11.25"
						stroke="#405664"
						stroke-width="1.2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
				<button
					class="flex flex-col flex-grow bg-gray-300 text-gray-700 font-semibold py-2 px-4"
					type="button"
					@click="toggle('filter-prop-price')"
				>
					<span class="text-[10px] text-mid-grey mb-1">{{
						__("Price starting at", "ccave")
					}}</span>
					<div class="flex items-center w-full">
						<span id="property-type-title" class="mr-1 text-sm py-[5px]">{{
							getPriceTitle()
						}}</span>
						<svg
							class="fill-current ml-auto -mt-3 h-4 w-4"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20"
						>
							<path
								d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
							/>
						</svg>
					</div>
				</button>
				<ul
					id="filter-prop-price"
					class="bg-white absolute hidden activity-select"
					@click="toggle('filter-prop-price')"
				>
					<li
						class="block cursor-pointer px-6 py-4"
						@click="setFilter('price', [0, 150000])"
					>
						{{ __("up to 150 000", "ccave") }}
					</li>
					<li
						class="block cursor-pointer px-6 py-4"
						@click="setFilter('price', [150000, 350000])"
					>
						{{ __("150 000 - 350 000", "ccave") }}
					</li>
					<li
						class="block cursor-pointer px-6 py-4"
						@click="setFilter('price', [350000, 750000])"
					>
						{{ __("350 000 - 750 000", "ccave") }}
					</li>
					<li
						class="block cursor-pointer px-6 py-4"
						@click="setFilter('price', [750000, 1000000])"
					>
						{{ __("750 000 - 1M", "ccave") }}
					</li>
					<li
						class="block cursor-pointer px-6 py-4"
						@click="setFilter('price', [1000000, 99999999])"
					>
						{{ __("above 1M", "ccave") }}
					</li>
					<button
						type="button"
						class="block px-6 py-4"
						href="javascript:void(0);"
						@click="clearFilter('price')"
					>
						{{ __("Clear", "ccave") }}
					</button>
				</ul>
			</div>
			<div
				class="flex items-center bg-white border border-light-grey rounded-sm relative"
			>
				<svg
					class="ml-4 flex-shrink-0"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M3.49238 2.84016C3.89228 2.55134 4.39566 2.39844 4.99992 2.39844H18.9999C19.6042 2.39844 20.1076 2.55134 20.5075 2.84016C20.9036 3.12627 21.1515 3.51196 21.307 3.90063C21.6004 4.63403 21.6001 5.4804 21.5999 5.966L21.5999 5.99851V12.4101C21.9428 12.6874 22.164 13.0424 22.307 13.3999C22.6004 14.1333 22.6001 14.9797 22.5999 15.4653L22.5999 15.4978V18.4978C22.5999 18.8292 22.3313 19.0979 21.9999 19.0979H21.5999V20.9985C21.5999 21.3299 21.3313 21.5985 20.9999 21.5985C20.6685 21.5985 20.3999 21.3299 20.3999 20.9985V19.0979H3.59991V20.9985C3.59991 21.3299 3.33128 21.5985 2.99991 21.5985C2.66854 21.5985 2.39991 21.3299 2.39991 20.9985V19.0979H1.99992C1.66855 19.0979 1.39992 18.8292 1.39992 18.4978V15.4978L1.39991 15.4653C1.39975 14.9797 1.39948 14.1333 1.69283 13.3999C1.83583 13.0424 2.05707 12.6874 2.39992 12.4101V5.99851L2.39991 5.966C2.39976 5.4804 2.39949 4.63402 2.69284 3.90063C2.8483 3.51196 3.09624 3.12627 3.49238 2.84016ZM20.3999 5.99851V11.9217C20.2719 11.9058 20.1386 11.8977 19.9999 11.8977H18.5V9.00003C18.5 8.17159 17.8284 7.5 17 7.5H14C13.1716 7.5 12.5 8.17159 12.5 9.00003V11.8977H11.5V9.00003C11.5 8.17159 10.8284 7.5 10 7.5H7C6.17158 7.5 5.5 8.17159 5.5 9.00003V11.8977H3.99992C3.86126 11.8977 3.72792 11.9058 3.59992 11.9217V5.99851C3.59992 5.47811 3.60702 4.84629 3.80701 4.34631C3.90154 4.10997 4.02861 3.93315 4.19497 3.813C4.35757 3.69556 4.60419 3.59846 4.99992 3.59846H18.9999C19.3957 3.59846 19.6423 3.69556 19.8049 3.813C19.9712 3.93315 20.0983 4.10997 20.1928 4.34631C20.3928 4.84629 20.3999 5.47811 20.3999 5.99851ZM13.5 11.8977V9.00003C13.5 8.72388 13.7239 8.50002 14 8.50002H17C17.2761 8.50002 17.5 8.72388 17.5 9.00003V11.8977H13.5ZM10.5 9.00003V11.8977H6.5V9.00003C6.5 8.72388 6.72386 8.50002 7 8.50002H10C10.2761 8.50002 10.5 8.72388 10.5 9.00003ZM2.807 13.8456C2.60701 14.3456 2.59992 14.9774 2.59992 15.4978V17.8978H21.3999V15.4978C21.3999 14.9774 21.3928 14.3456 21.1928 13.8456C21.0983 13.6092 20.9712 13.4324 20.8049 13.3123C20.6423 13.1948 20.3957 13.0977 19.9999 13.0977H3.99992C3.60418 13.0977 3.35756 13.1948 3.19496 13.3123C3.0286 13.4324 2.90154 13.6092 2.807 13.8456Z"
						fill="#405664"
					/>
				</svg>
				<button
					class="flex flex-col flex-grow bg-gray-300 text-gray-700 font-semibold py-2 px-4 w-full"
					type="button"
					@click="toggle('filter-prop-bedrooms')"
				>
					<span class="text-[10px] text-mid-grey mb-1">{{
						__("Number of Bedrooms", "ccave")
					}}</span>
					<div class="flex items-center w-full">
						<span
							v-show="activeBedroomsSize"
							id="bedrooms-title"
							class="mr-1"
							>{{ getBedroomsLabel(activeBedroomsSize) }}</span
						>
						<span v-show="!activeBedroomsSize" class="mr-1">{{
							__("All", "ccave")
						}}</span>
						<svg
							class="fill-current ml-auto -mt-3 h-4 w-4"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20"
						>
							<path
								d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
							/>
						</svg>
					</div>
				</button>
				<ul
					id="filter-prop-bedrooms"
					class="bg-white absolute hidden activity-select"
				>
					<li
						class=""
						v-for="(i, index) in bedroomsForFilter"
						:key="index"
						@click="
							setFilter('bedrooms', i);
							toggle('filter-prop-bedrooms');
						"
					>
						<span class="block cursor-pointer px-6 py-4">{{
							getBedroomsLabel(i)
						}}</span>
					</li>
					<button
						type="button"
						class="block px-6 py-4"
						@click="
							clearFilter('bedrooms');
							toggle('filter-prop-bedrooms');
						"
					>
						{{ __("Clear", "ccave") }}
					</button>
				</ul>
			</div>
			<div
				class="flex items-center bg-white border border-light-grey rounded-sm relative"
			>
				<svg
					class="ml-4 flex-shrink-0"
					width="18"
					height="19"
					viewBox="0 0 18 19"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M9.05054 0.00244472C9.03402 0.000827645 9.01727 0 9.00032 0C8.98337 0 8.96662 0.000827646 8.95009 0.00244473L0.509433 0.00244496C0.22808 0.00244497 0 0.23055 0 0.511932V17.4948C0 17.7762 0.228081 18.0043 0.509434 18.0043H8.98788L9.00032 18.0045C9.28167 18.0045 9.50975 17.7764 9.50975 17.495L9.50975 12.4001C9.50975 12.1187 9.28167 11.8906 9.00032 11.8906C8.71897 11.8906 8.49088 12.1187 8.49088 12.4001V16.9853H1.01887L1.01887 1.02142L8.49088 1.02142V8.49219H3.90592C3.62457 8.49219 3.39649 8.72029 3.39649 9.00167C3.39649 9.28306 3.62457 9.51116 3.90592 9.51116H14.0946C14.376 9.51116 14.604 9.28306 14.604 9.00167C14.604 8.72029 14.376 8.49219 14.0946 8.49219H9.50975V1.02142L16.9811 1.02142L16.9811 16.9853H12.8208C12.5394 16.9853 12.3113 17.2135 12.3113 17.4948C12.3113 17.7762 12.5394 18.0043 12.8208 18.0043H17.4906C17.7719 18.0043 18 17.7762 18 17.4948V0.511932C18 0.23055 17.7719 0.00244448 17.4906 0.00244449L9.05054 0.00244472Z"
						fill="#405664"
					/>
				</svg>
				<div
					class="flex flex-col flex-grow bg-gray-300 text-gray-700 font-semibold py-2 px-4 w-full"
					@click="toggle('filter-prop-size')"
				>
					<span class="text-[10px] text-mid-grey mb-1">{{
						__("Size", "ccave")
					}}</span>
					<div class="flex items-center w-full">
						<span v-if="!minSize && !maxSize" id="size-title" class="mr-1">{{
							__("All", "ccave")
						}}</span>
						<span v-else-if="!minSize" class="mr-1">0 - {{ maxSize }} m²</span>
						<span v-else-if="!maxSize" class="mr-1">{{ minSize }} - ∞ m²</span>
						<span v-else class="mr-1">{{ minSize }} - {{ maxSize }} m²</span>
						<svg
							class="fill-current ml-auto -mt-3 h-4 w-4"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20"
						>
							<path
								d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
							/>
						</svg>
					</div>
				</div>
				<div
					id="filter-prop-size"
					class="bg-white absolute hidden activity-select px-6 py-4"
				>
					<div class="grid grid-cols-2 gap-6">
						<div>
							<label for="minSize">{{ __("Min:", "ccave") }}</label>
							<input
								class="border-b border-light-grey w-full focus:outline-none"
								type="number"
								id="min-size-input"
								name="minSize"
								step="10"
								v-model="minSize"
							/>
							<button class="pl-0" type="button" @click="minSize = false">
								{{ __("Clear", "ccave") }}
							</button>
						</div>
						<div>
							<label for="maxSize">{{ __("Max:", "ccave") }}</label>
							<input
								class="border-b border-light-grey w-full focus:outline-none"
								type="number"
								id="max-size-input"
								name="maxSize"
								step="10"
								v-model="maxSize"
							/>
							<button class="pl-0" type="button" @click="maxSize = false">
								{{ __("Clear", "ccave") }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- ./filter -->

		<div class="flex items-center mb-10 xl:mb-12 justify-end">
			<div class="flex items-center mr-auto">
				<div
					class="text-xs font-semibold tracking-little mr-14"
					v-show="availableProperties.length > 0"
				>
					{{ availableProperties.length }}
					{{ __("PROPERTIES AVAILABLE", "ccave") }}
				</div>
				<div
					class="form-control form-control--clean custom-checkbox"
					v-if="!isResalePage"
				>
					<label class="ml-4 w-full" :for="resale">
						<input
							type="checkbox"
							:id="resale"
							:value="resale"
							v-model="resale"
							@change="resaleCheckbox($event)"
						/>
						<span class="text-navy-blue-01">{{ __("RESALE", "ccave") }}</span>
					</label>
				</div>
			</div>

			<div class="inline-block rounded-sm relative ml-12">
				<button
					class="flex items-center font-semibold py-2 px-4 w-full"
					type="button"
					@click="toggle('filter-prop-sort')"
				>
					<span id="size-title" class="text-xs tracking-little">{{
						this.activeSorting.name
					}}</span>
					<svg
						class="fill-current ml-6 h-4 w-4"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 20 20"
					>
						<path
							d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
						/>
					</svg>
				</button>
				<ul
					id="filter-prop-sort"
					class="bg-white absolute hidden activity-select"
				>
					<li
						class=""
						v-for="(option, index) in sortingOptions"
						:key="index"
						@click="
							setSorting(option);
							toggle('filter-prop-sort');
						"
					>
						<a class="block px-6 py-4" href="javascript:void(0);">{{
							option.name
						}}</a>
					</li>
				</ul>
			</div>

			<!-- Reset  filter -->
			<button
				type="button"
				class="flex items-center text-xs font-semibold tracking-little ml-12"
				@click="resetFilters()"
			>
				{{ __("RESET FILTERS", "ccave") }}
				<svg
					class="ml-6"
					width="24"
					height="24"
					viewBox="0 0 24 24"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M5.24999 4.40234L19.5985 18.7509L18.75 19.5994L4.40146 5.25087L5.24999 4.40234Z"
						fill="#808F98"
					/>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M19.5985 5.25087L5.24999 19.5994L4.40146 18.7509L18.75 4.40234L19.5985 5.25087Z"
						fill="#808F98"
					/>
				</svg>
			</button>
			<!-- ./Reset  filter -->
		</div>

		<XyzTransitionGroup
			appear-visible
			class="property-list flex flex-col md:flex-row mb-6"
			v-show="filteredProperties.length > 0"
			v-for="(property, index) in filteredProperties"
			:key="index"
			xyz="delay-2 fade down"
		>
			<div class="overflow-hidden w-full md:w-5/12" :key="index + 'img'">
				<img
					class="object-cover w-full h-full"
					v-show="property.data.fields.image"
					:src="property.data.fields.image.sizes.customslide"
					:alt="property.data.fields.image.alt"
				/>
			</div>

			<div
				class="flex flex-col justify-center md:px-14 py-4 w-full md:w-7/12 self-stretch"
				:key="index + 'content'"
			>
				<div class="text-sm mb-1" v-show="property.property_type">
					{{ getPropertyTypeName(property.property_type[0]) }}
				</div>
				<h4
					class="text-2xl font-normal xl:font-light mb-4 xl:mb-5"
					v-show="property.title"
					v-html="property.title.rendered"
				></h4>
				<div
					class="hidden md:block leading-normal mb-8"
					v-show="property.data.fields.text"
					v-html="property.data.fields.text"
				></div>

				<div class="flex items-center mb-6 xl:mb-8">
					<div
						class="flex items-center text-sm xl:text-base mr-5 xl:mr-10 whitespace-nowrap"
						v-show="property.data.fields.price"
					>
						<svg
							class="mr-2 w-4 xl:w-6"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M17.523 18.273C16.579 19.217 15.3762 19.8599 14.0669 20.1203C12.7575 20.3808 11.4003 20.2471 10.1669 19.7362C8.93348 19.2253 7.87928 18.3601 7.13758 17.2501C6.39588 16.1401 6 14.835 6 13.5V10.5C6 9.16498 6.39588 7.85994 7.13758 6.7499C7.87928 5.63987 8.93348 4.77471 10.1669 4.26382C11.4003 3.75292 12.7575 3.61925 14.0669 3.8797C15.3762 4.14015 16.579 4.78303 17.523 5.72703"
								stroke="#405664"
								stroke-width="1.2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M3.75 10.5H12.75"
								stroke="#405664"
								stroke-width="1.2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
							<path
								d="M3.75 13.5H11.25"
								stroke="#405664"
								stroke-width="1.2"
								stroke-linecap="round"
								stroke-linejoin="round"
							/>
						</svg>
						{{ property.data.fields.price }}
					</div>
					<div
						class="flex items-center text-sm xl:text-base mr-5 xl:mr-10 whitespace-nowrap"
						v-show="property.data.fields.number_of_bedrooms"
					>
						<svg
							class="mr-2 w-4 xl:w-6"
							width="32"
							height="32"
							viewBox="0 0 32 32"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M4.28198 3.0242C4.83279 2.61505 5.52612 2.39844 6.35841 2.39844H25.6414C26.4737 2.39844 27.167 2.61505 27.7178 3.0242C28.2635 3.42951 28.605 3.9759 28.8191 4.52651C29.2232 5.56546 29.2228 6.76446 29.2226 7.45238L29.2226 7.49844V16.5814C29.6948 16.9742 29.9995 17.4771 30.1965 17.9835C30.6005 19.0225 30.6001 20.2215 30.5999 20.9094L30.5999 20.9555V25.2055C30.5999 25.6749 30.2299 26.0555 29.7735 26.0555H29.2225V28.7497C29.2225 29.2192 28.8525 29.5997 28.3961 29.5997C27.9397 29.5997 27.5697 29.2192 27.5697 28.7497V26.0555H4.43009V28.7497C4.43009 29.2192 4.06009 29.5997 3.60368 29.5997C3.14726 29.5997 2.77726 29.2192 2.77726 28.7497V26.0555H2.22634C1.76992 26.0555 1.39992 25.6749 1.39992 25.2055V20.9555L1.39991 20.9094C1.3997 20.2215 1.39932 19.0225 1.80337 17.9835C2.00033 17.4771 2.30506 16.9742 2.77728 16.5814V7.49844L2.77727 7.45238C2.77705 6.76446 2.77668 5.56546 3.18073 4.52651C3.39486 3.9759 3.73636 3.42951 4.28198 3.0242ZM27.5697 7.49844V15.8894C27.3934 15.8669 27.2098 15.8555 27.0188 15.8555H24.9529V11.75C24.9529 10.5764 24.0279 9.625 22.8868 9.625H18.7547C17.6137 9.625 16.6887 10.5764 16.6887 11.75V15.8555H15.3114V11.75C15.3114 10.5764 14.3864 9.625 13.2453 9.625H9.11324C7.9722 9.625 7.0472 10.5764 7.0472 11.75V15.8555H4.98105C4.79007 15.8555 4.60641 15.8669 4.43011 15.8894V7.49844C4.43011 6.76122 4.43989 5.86616 4.71534 5.15787C4.84555 4.82306 5.02056 4.57257 5.2497 4.40236C5.47366 4.23599 5.81334 4.09844 6.35841 4.09844H25.6414C26.1865 4.09844 26.5262 4.23599 26.7501 4.40236C26.9793 4.57257 27.1543 4.82306 27.2845 5.15787C27.5599 5.86616 27.5697 6.76122 27.5697 7.49844ZM18.0661 15.8555V11.75C18.0661 11.3588 18.3744 11.0417 18.7547 11.0417H22.8868C23.2672 11.0417 23.5755 11.3588 23.5755 11.75V15.8555H18.0661ZM13.934 11.75V15.8555H8.42456V11.75C8.42456 11.3588 8.73289 11.0417 9.11324 11.0417H13.2453C13.6257 11.0417 13.934 11.3588 13.934 11.75ZM3.33798 18.6149C3.06253 19.3232 3.05275 20.2183 3.05275 20.9555V24.3555H28.9471V20.9555C28.9471 20.2183 28.9373 19.3232 28.6618 18.6149C28.5316 18.2801 28.3566 18.0296 28.1275 17.8594C27.9035 17.693 27.5638 17.5555 27.0188 17.5555H4.98105C4.43599 17.5555 4.0963 17.693 3.87234 17.8594C3.6432 18.0296 3.46819 18.2801 3.33798 18.6149Z"
								fill="#808F98"
							/>
						</svg>
						{{
							getBedroomsLabelForSingleProperty(
								property.data.fields.number_of_bedrooms
							)
						}}
					</div>
					<div
						class="flex items-center mr-5 xl:mr-10 text-sm xl:text-base whitespace-nowrap"
						v-show="property.data.fields.size"
					>
						<svg
							class="mr-2 w-4 xl:w-6"
							width="32"
							height="32"
							viewBox="0 0 32 32"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M16.0856 3.00487C16.0577 3.00165 16.0293 3 16.0005 3C15.9717 3 15.9432 3.00165 15.9153 3.00487L3.73585 3.00488C3.32945 3.00488 3 3.33433 3 3.74074V28.2694C3 28.6758 3.32945 29.0052 3.73585 29.0052H16C16.3297 29.0052 16.6087 28.7884 16.7023 28.4896C16.7244 28.4197 16.7363 28.3452 16.7363 28.2679L16.7363 20.9093C16.7363 20.5029 16.4069 20.1735 16.0005 20.1735C15.5941 20.1735 15.2646 20.5029 15.2646 20.9093V27.5335H4.4717L4.4717 4.4766L15.2646 4.47659V15.2657H8.64188C8.23548 15.2657 7.90603 15.5952 7.90603 16.0016C7.90603 16.408 8.23548 16.7375 8.64188 16.7375H23.3589C23.7653 16.7375 24.0947 16.408 24.0947 16.0016C24.0947 15.5952 23.7653 15.2657 23.3589 15.2657H16.7363V4.47659L27.5283 4.47659L27.5283 27.5335H21.5189C21.1125 27.5335 20.783 27.863 20.783 28.2694C20.783 28.6758 21.1125 29.0052 21.5189 29.0052L28.2642 29.0052C28.6705 29.0052 29 28.6758 29 28.2694L29 3.74073C29 3.33433 28.6705 3.00487 28.2641 3.00487L16.0856 3.00487Z"
								fill="#808F98"
							/>
						</svg>
						{{ property.data.fields.size }} m²
					</div>
				</div>

				<a class="btn btn-blue self-start rounded-sm" :href="property.link">{{
					__("VIEW DETAILS", "ccave")
				}}</a>
			</div>
		</XyzTransitionGroup>

		<div class="flex mb-6" v-show="filteredProperties.length === 0">
			{{
				__(
					"No results with this filter criteria. Change or reset filter/filters.",
					"ccave"
				)
			}}
		</div>
		<div
			v-if="propertiesAll"
			v-observe-visibility="{ callback: loadMore, throttle: 300 }"
		></div>
	</section>
</template>

<script>
export default {
	name: "PropertiesList",
	data() {
		return {
			properties: false,
			propertiesAll: false,
			propertyTypes: [],

			activeNeigbourhood: false,
			activePropertyType: false,
			activeBedroomsSize: false,

			priceMin: false,
			priceMax: false,

			minSize: false,
			maxSize: false,

			resale: false,

			bedroomsForFilter: [],

			activeSorting: false,
			sortingOptions: [
				{ id: "ASC", name: this.__("ASCENDING PRICE", "ccave") },
				{ id: "DESC", name: this.__("DESCENDING PRICE", "ccave") },
			],
			sliceStart: 0,
			sliceEnd: 30,
		};
	},
	mounted() {
		if (this.isResalePage) {
			this.resale = true;
		}

		this.activeSorting = this.sortingOptions[0];
		this.getP();
		this.activeNeigbourhood = this.neighbourhoodsData[0];
	},

	computed: {
		// Used for resale-based pages only
		isResalePage() {
			// return window.location.pathname.includes('/resale-test-page'); // slug-based
			const pageIds = [35709];
			return pageIds.some((id) =>
				document.body.classList.contains(`page-id-${id}`)
			); // id-based (better!)
		},
		filteredProperties() {
			let results = this.properties;
			if (this.properties) {
				if (this.activeNeigbourhood) {
					results = results.filter((p) =>
						p.neighbourhood.includes(this.activeNeigbourhood.term_id)
					);
				}
				if (this.activePropertyType) {
					results = results.filter((p) =>
						p.property_type.includes(this.activePropertyType)
					);
				}
				if (this.activeBedroomsSize) {
					results = results.filter(
						(p) =>
							parseInt(p.data.fields.number_of_bedrooms) ===
							this.activeBedroomsSize
					);
				}
				if (this.minSize) {
					results = results.filter(
						(p) => parseInt(p.data.fields.size) >= this.minSize
					);
				}
				if (this.maxSize) {
					results = results.filter(
						(p) => parseInt(p.data.fields.size) <= this.maxSize
					);
				}
			}
			return results;
		},
		availableProperties() {
			let results = this.properties;
			if (this.properties) {
				if (this.activePropertyType) {
					results = results.filter((p) =>
						p.property_type.includes(this.activePropertyType)
					);
				}
				if (this.activeBedroomsSize) {
					results = results.filter(
						(p) =>
							parseInt(p.data.fields.number_of_bedrooms) ===
							this.activeBedroomsSize
					);
				}
				if (this.minSize) {
					results = results.filter(
						(p) => parseInt(p.data.fields.size) >= this.minSize
					);
				}
				if (this.maxSize) {
					results = results.filter(
						(p) => parseInt(p.data.fields.size) <= this.maxSize
					);
				}
			}
			return results;
		},
		availableNeigbourhoods() {
			let results = [];
			let availableProperties = this.properties;
			if (this.properties) {
				if (this.activePropertyType) {
					availableProperties = availableProperties.filter((p) =>
						p.property_type.includes(this.activePropertyType)
					);
				}
				if (this.activeBedroomsSize) {
					availableProperties = availableProperties.filter(
						(p) =>
							parseInt(p.data.fields.number_of_bedrooms) ===
							this.activeBedroomsSize
					);
				}
				if (this.minSize) {
					availableProperties = availableProperties.filter(
						(p) => parseInt(p.data.fields.size) >= this.minSize
					);
				}
				if (this.maxSize) {
					availableProperties = availableProperties.filter(
						(p) => parseInt(p.data.fields.size) <= this.maxSize
					);
				}
			}
			if (availableProperties.length > 0) {
				availableProperties.forEach((property) => {
					results.push(property.neighbourhood[0]);
				});
			}
			results = results
				.map((result) => result)
				.filter((value, index, self) => self.indexOf(value) === index);

			let availableNeigbourhoods = [];
			results.forEach((neighbourhood_id) => {
				this.neighbourhoodsData.forEach((neighbourhood) => {
					if (neighbourhood.term_id === neighbourhood_id) {
						availableNeigbourhoods.push(neighbourhood);
					}
				});
			});

			return [...availableNeigbourhoods].reverse();
		},
	},
	watch: {
		availableNeigbourhoods: {
			immediate: true,
			handler(newNeighbourhoods) {
				if (newNeighbourhoods && newNeighbourhoods.length > 0) {
					if (
						!this.activeNeigbourhood ||
						!newNeighbourhoods.some(
							(n) => n.term_id === this.activeNeigbourhood.term_id
						)
					) {
						this.activeNeigbourhood = newNeighbourhoods[0];
						this.updateScroll();
					}
				} else {
					this.activeNeigbourhood = false;
				}
			},
		},
	},
	methods: {
		loadMore(isVisible, entry) {
			if (isVisible && this.properties.length < this.propertiesAll.length) {
				this.sliceStart = this.sliceEnd;
				this.sliceEnd += this.sliceEnd;
				this.properties = this.properties.concat(
					this.propertiesAll.slice(this.sliceStart, this.sliceEnd)
				);

				this.filterBedrooms();
				this.updateScroll();
			}
		},
		updateScroll() {
			/*this.$nextTick(() => {
                    setTimeout(() => {
                        this.$root.scroll.update()
                    }, 200);
                });*/
		},
		setSorting(option) {
			this.activeSorting = option;
			this.getP();
		},
		getP() {
			this.priceMin = !this.priceMin ? 0 : this.priceMin;
			this.priceMax = !this.priceMax ? 99999999 : this.priceMax;

			let url_params = {
				sort: this.activeSorting.id,
				price_min: this.priceMin,
				price_max: this.priceMax,
				resale: this.resale,
				/* 'per_page'                  : this.perPage,
                        'page'                      : this.page,   */
			};

			var searchParams = new URLSearchParams(url_params);

			this.$http
				.post(
					this.endpoints.rest_base_endpoint + "lustica/v1/filter_properties",
					searchParams,
					{
						headers: {
							Accept: "application/json",
							"Content-Type":
								"application/x-www-form-urlencoded; charset=UTF-8",
						},
					}
				)
				.then((res) => {
					this.propertiesAll = res.data.data.posts;
					this.properties = this.propertiesAll.slice(
						this.sliceStart,
						this.sliceEnd
					);
					/* this.hasMore = res.data.data.has_more */
					/* this.properties.forEach(p => {
                        }); */
					this.getPropertyTypes();
					this.filterBedrooms();
					this.updateScroll();
				});
		},
		getPropertyTypes() {
			this.$http
				.get(this.endpoints.rest_base_endpoint + "wp/v2/property_type")
				.then((res) => {
					this.propertyTypes = res.data;
				});
		},
		getPropertyTypeName(propertyTypeId) {
			let found = this.propertyTypes.filter(
				(property) => property.id === propertyTypeId
			);
			return found.length > 0 ? found[0].name : "";
		},
		setFilter(filterName, category) {
			if (filterName === "type") {
				this.activePropertyType = category.id;
				document.getElementById("property-type-title").innerHTML =
					category.name;
			} else if (filterName === "bedrooms") {
				this.activeBedroomsSize = parseInt(category);
			} else if (filterName === "price") {
				this.priceMin = category[0];
				this.priceMax = category[1];
			}
			this.getP();
			this.activeNeigbourhood = this.availableNeigbourhoods[0];
		},
		clearFilter(filterName) {
			if (filterName === "type") {
				this.activePropertyType = false;
				document.getElementById("property-type-title").innerHTML = this.__(
					"All Property Types",
					"ccave"
				);
			} else if (filterName === "bedrooms") {
				this.activeBedroomsSize = false;
				document.getElementById("bedrooms-title").innerHTML = this.__(
					"All",
					"ccave"
				);
			} else if (filterName === "price") {
				this.priceMin = 0;
				this.priceMax = false;
			}
			this.getP();
		},
		resetFilters() {
			this.activePropertyType = false;
			document.getElementById("property-type-title").innerHTML = this.__(
				"All Property Types",
				"ccave"
			);
			this.activeBedroomsSize = false;
			this.priceMin = false;
			this.minSize = false;
			this.maxSize = false;
			this.resale = false;
			this.getP();
		},
		/* goToLocation(event) {
                window.location.href = event.link;
            }, */
		filterBedrooms() {
			let results = [];
			this.properties.some((property) => {
				results.push(parseInt(property.data.fields.number_of_bedrooms));
			});
			results.sort(function (a, b) {
				return a - b;
			});
			this.bedroomsForFilter = results
				.map((result) => result)
				.filter((value, index, self) => self.indexOf(value) === index);
		},
		getBedroomsLabel(number) {
			if (number === -1) {
				return this.__("Studio", "ccave");
			} else if (number === 1) {
				return number + " " + this.__("bedroom", "ccave");
			} else if (number > 0 && number < 5) {
				return number + " " + this.__("bedrooms", "ccave");
			} else if (number >= 5) {
				return number + " " + this.__("and more bedrooms", "ccave");
			}
		},
		getBedroomsLabelForSingleProperty(number) {
			number = parseInt(number);
			if (number === -1) {
				return this.__("Studio", "ccave");
			} else if (number === 1) {
				return number + " " + this.__("bedroom", "ccave");
			} else if (number > 1) {
				return number + " " + this.__("Bedrooms", "ccave");
			}
		},
		getPriceTitle() {
			if (this.priceMin === 0 && this.priceMax === 99999999) {
				return 0;
			} else if (this.priceMin === 0 && this.priceMax === 150000) {
				return this.__("up too", "ccave") + " " + this.priceMax;
			} else if (this.priceMin === 150000 && this.priceMax === 350000) {
				return this.priceMin + " - " + this.priceMax;
			} else if (this.priceMin === 350000 && this.priceMax === 750000) {
				return this.priceMin + " - " + this.priceMax;
			} else if (this.priceMin === 750000 && this.priceMax === 1000000) {
				return this.priceMin + " - " + this.__("1M", "ccave");
			} else if (this.priceMin === 1000000 && this.priceMax === 99999999) {
				return this.__("above 1M", "ccave");
			}
		},
		resaleCheckbox(e) {
			this.getP();
		},
		toggle(id) {
			let el = document.getElementById(id);
			if (el.classList.contains("hidden")) {
				el.classList.remove("hidden");
				el.classList.add("visible");
			} else {
				el.classList.remove("visible");
				el.classList.add("hidden");
			}
		},
	},
};
</script>
